<template>
  <div>
    <a-card style="height: auto">
      <p>Card content</p>
      <p>Card content</p>
      <p>Card content</p>
    </a-card>
  </div>
</template>

<script>
import PageLayout from '@/layouts/PageLayout'
import {mapState} from 'vuex'

export default {
  name: 'WorkPlace',
  components: {PageLayout},
  i18n: require('./i18n'),
  data() {
    return {
      projects: [],
      loading: true,
      activities: [],
      teams: [],
      welcome: {
        timeFix: '',
        message: ''
      }
    }
  },
  computed: {
    ...mapState('account', {currUser: 'user'}),
    ...mapState('setting', ['lang'])
  },
  created() {

  }
}
</script>

<style lang="less">
@import "index";
</style>
